import { Router } from '@angular/router';
import { SectorModel } from './../../service/sector.model';
import { HttpClient } from '@angular/common/http';
import { DropzoneComponent, DropzoneConfigInterface, DROPZONE_CONFIG, DropzoneDirective } from 'ngx-dropzone-wrapper';
import { TrainService } from './../../service/train.service';
import { DBConnectorService } from './../../service/test.service';
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Observable, Subscription, interval } from 'rxjs';
import { LoggedInGuard } from '../../authentication/logged-in.guard';
// import { DialogService } from 'ng2-bootstrap-modal';
import { ShowLogDialogComponent } from '../../show-log-dialog/show-log-dialog.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-trainwithxls',
  templateUrl: './trainwithxls.component.html',
  styleUrls: ['./trainwithxls.component.css']
})
export class TrainxlsComponent implements OnInit, OnDestroy {

  bsModalRef: BsModalRef;
  @ViewChild(DropzoneDirective) directiveRef: DropzoneDirective;
  enableGetLogs: boolean;
  sectormodel = new SectorModel;
  click = true;
  result:any = {};
  sub: Subscription;
  Status: string;
  isDiabled = false;
  isLabelMapping: String;

  public config: DropzoneConfigInterface = {
    url: '/api/TrainExisting/UploadTrainXlsFile',
    clickable: true,
    headers: {
      'Sector': this.dbconnectorservice.SectorName,
      'Model': this.dbconnectorservice.ModelName
    },
    uploadMultiple: true,
    parallelUploads: 3,
    autoReset: null,
    errorReset: 15000,
    cancelReset: 15000,
    createImageThumbnails: true,
    dictDefaultMessage: 'Drag and Drop or Click to browse for files',
    acceptedFiles: '.xlsm,.xlsx',
  };

  constructor(private dbconnectorservice: DBConnectorService,
    private trainservice: TrainService,
    private http: HttpClient,
    private router: Router,
    private loggedInGuard: LoggedInGuard,
    private _dialogService: BsModalService
    ) {

    this.sectormodel.SectorName = this.dbconnectorservice.SectorName;
    this.sectormodel.ModelName = this.dbconnectorservice.ModelName;
    this.sectormodel.User = this.dbconnectorservice.username;
    this.configset();
  }

  configset() {
    const url1 = '/api/TrainExisting/UploadTrainXlsFile';
    // const resource = this.adalService.GetResourceForEndpoint(url1);
    // const token = this.adalService.getCachedToken(resource);
    // const tokenbearer = 'Bearer ' + token;

    this.config = {
      url: url1,
      headers: {
        'Authorization': this.dbconnectorservice.getToken(url1),
        'Sector': this.dbconnectorservice.SectorName,
        'Model': this.dbconnectorservice.ModelName
      },
      uploadMultiple: true,
      parallelUploads: 3,
      autoReset: null,
      errorReset: 15000,
      cancelReset: 15000,
      createImageThumbnails: true,
      dictDefaultMessage: 'Drag and Drop or Click to browse for files',
      acceptedFiles: '.xlsm,.xlsx',
      clickable: true,
      timeout: 240000
    };
  }
  onUploadError(args: any) {
    // console.log('onUploadError:', args);
  }

  onUploadSuccess(args: any) {
    // console.log('onUploadSuccess:', args);
    this.result = args[1];
  }

  TrainNowUploadedTrainXls() {
    if (this.loggedInGuard.isSessionValid()) {
      this.enableGetLogs = true;
      this.trainservice.IsLabelMappingTrainExisting(this.sectormodel)
        .subscribe(
          (data) => {
            this.result = data;
            this.isLabelMapping = data.Message;
            // return this.result;
            if (this.isLabelMapping === '1') {
              this.click = false;
              console.log('Train - start');
              this.isDiabled = true;
              this.trainservice.TrainExisting(this.sectormodel)
                .subscribe(
                  (data) => {
                    this.result = data;
                    console.log(this.result);
                    console.log('Train - after api');
                    if (data['Train']) {
                      this.router.navigate(['Train/Step3Done']);
                    }
                    this.isDiabled = false;
                  });
            } else {
              alert('Please Train with new data')
              this.router.navigate(['/Train']);
            }
          });
    }
  }

  // IsLabelMapping(){

  //   this.trainservice.IsLabelMappingTrainExisting(this.sectormodel)
  //   .subscribe(
  //     (data) => {
  //       this.result = data;
  //       this.isLabelMapping=data.Message;
  //       return this.result;
  //     });

  // }

  redirect() {
    this.router.navigate(['Home/Update']);
  }

  CancelTrain() {
    this.trainservice.cancelTrain(this.sectormodel)
      .subscribe(
        (data) => { });
  }

  StatusCheck() {
    this.trainservice.statusCheck(this.sectormodel)
      .subscribe(
        (data) => {
          this.Status = data;
          if (this.Status === 'PROCESSING EXIST') {
            this.click = false;
            this.enableGetLogs = true;
          } else if (this.Status === 'PROCESSED' && this.click === false) {
            this.router.navigate(['Train/Step3']);
          } else {
            this.click = true;
          }
          console.log(this.Status);
        });

  }

  ngOnInit() {
    this.StatusCheck();
    this.sub = interval(5000).subscribe(x => {
      if (this.click === false) {
        this.StatusCheck();
      }
    });
  }

  ngOnDestroy() {
    if (this.sub != null) {
      this.sub.unsubscribe();
    }
  }
  OpenLogsDialog() {
    console.log("clicked!")
    const initialState = {
      source: "training",
      username: this.sectormodel.User
    };
    this.bsModalRef = this._dialogService.show(ShowLogDialogComponent, { initialState })
    //this._dialogService.addDialog(ShowLogDialogComponent, { source: "training", username: this.sectormodel.User }).subscribe(data => console.log(data))
  }
}
